/**
 * Shared CEX query keys for cross-entity cache invalidation.
 * Bot entities use these keys to invalidate parent CEX entity caches.
 */
export const CEX_BOT_STATES_QUERY_KEY = ['cex', 'bot-states'] as const;

/**
 * Creates a query key for CEX bot states with optional pairId.
 */
export const cexBotStatesQueryKey = (pairId?: number) =>
  [...CEX_BOT_STATES_QUERY_KEY, pairId] as const;
